import { FC, useState, useEffect, useMemo, useRef } from 'react';
import { useMethods } from '@lhb/hook';
import { isArray, isNotEmptyAny } from '@lhb/func';
import styles from '../index.module.less';
import FirstScreenMap from './FirstScreenMap';
import FirstScreenRight from './FirstScreenRight';
import TypeOfBusiness from './TypeOfBusiness/TypeOfBusiness';
// import POIMating from './TypeOfBusiness/POIMating';
// import PassengerFlowPortrait from '@/views/iterate/pages/siteselectionmap/components/AreaDetailDrawer/PassengerFlowPortrait';
import PassengerFlowPortrait from '@/common/components/business/PassengerFlowPortrait';

import {
  postShareSpotEvaluationCityInfo,
  getSpotEvaluationCityInfo,
  postCombatMapQueryTendencyV2,
  postQueryMonthTendency,
  postQueryOpeningTendency,
  postShareCombatMapQueryTendencyV2,
  postShareQueryMonthTendency,
  postShareQueryOpeningTendency,
  postShareShopStatusCount,
  postShopStatusCount,
  spotEvaluationLegend,
  spotEvaluationLegendShare,
  spotEvaluationPopulation,
  spotEvaluationPopulationShare,
  getSpotEvaluationConfigData,
  getSpotEvaluationShareConfigData
} from '@/common/api/spotevaluation';
import { DrawerDataProps, SpotTypeEnum } from '../../../ts-config';
import V2Tabs from '@/common/components/Data/V2Tabs';
import CityInfo from './FirstScreenRight/components/CityInfo';
import { getTenantShareInfo, getYouthMapDefaultConfig, postShareYouthMapDefaultConfig } from '@/common/api/youth';
import { getCookie } from '@lhb/cache';

enum ActiveKeyEnum {
  'Info'='1',
 'CityInfo'='2',
}

/**
 * 详情主体
 */
const Main: FC<{
  drawerData: DrawerDataProps;
  mainHeight?: string;
  detail: any;
  overViewData: any;
  isMallType: boolean;
  tenantId: string;
  configSwitch: any;
  shareParams?: any;
  isSemirModel: boolean;
  isStartAnalyseOfAI?: boolean;
  setIsStartAnalyseOfAI?: any;
  agentTenant?: any;
}> = ({
  drawerData,
  mainHeight,
  detail,
  overViewData,
  isMallType,
  tenantId,
  configSwitch,
  shareParams,
  isSemirModel,
  isStartAnalyseOfAI,
  setIsStartAnalyseOfAI,
  agentTenant,
}) => {
  const [mapIns, setMapIns] = useState<any>(null); // 地图实例
  const [mapDom, setMapDom] = useState<any>(null); // 地图Dom
  const [tmpLegendData, setTmpLegendData] = useState<any>([]); // 图例原始数据
  const [storeOptions, setStoreOptions] = useState<any>({}); // 经营门店所有tab展示选项
  const [surroundingOptions, setSurroundingOptions] = useState<any>({}); // 周边配套所有tab展示选项
  const [storeChecked, setStoreChecked] = useState<any>({}); // 经营门店选中项
  const [surroundingChecked, setSurroundingChecked] = useState<any>({}); // 周边配套选中项
  const [ageDetail, setAgeDetail] = useState<any>({}); // 年龄分布
  const [curDetail, setCurDetail] = useState<any>(null);// 经营门店或周边配套选中的表格项
  const [isOpenHeatMap, setIsOpenHeatMap] = useState<boolean>(false);// 是否打开热力
  const [competitorInfo, setCompetitorInfo] = useState<any>([]); // 关注品牌
  const [brandStoreTendency, setBrandStoreTendency] = useState<any>([]); // 品牌门店趋势
  const [activeKey, setActiveKey] = useState<string>(ActiveKeyEnum.Info); // tabs
  const [cityInfo, setCityInfo] = useState<any>({}); // 城市信息
  const [statesTabs, setStatesTabs] = useState<any>([]); // 门店状态的数量
  const [youthDefaultConfig, setYouthDefaultConfig] = useState<any>({}); // 青春版默认配置(租户级别的，不跟模型走)
  const [spotEvaluationConfig, setSpotEvaluationConfig] = useState<any>({});


  const rangeMarkerRef = useRef<any>({
    markerOf500: null,
    markerOf1500: null,
    markerOf3000: null,
  });
  /** 客流画像在半径为 10000 时不显示 */
  const passengerFlowPortraitVisible = +detail.radius !== 10000;

  /**
   * 首屏右侧高度
   */
  const calculateHeight = useMemo((): number => {
    const parsedHeight = Number(mainHeight);
    if (isNaN(parsedHeight)) {
      return 80;
    }
    const calculatedHeight = Math.max(0, parsedHeight - 80);
    return calculatedHeight;
  }, [mainHeight]);

  useEffect(() => {
    const { open, lng, lat } = drawerData || {};
    if (open && lng && lat) {
      methods.loadLegend();
      // 客流画像在半径为 10000 时不获取数据
      passengerFlowPortraitVisible && methods.loadAgeDetail();
      methods.getMapDefaultConfig();
      methods.getCompetitorInfo();
    }
  }, [drawerData]);

  const items = useMemo(() => {
    const list = [
      {
        key: ActiveKeyEnum.Info,
        label: drawerData?.type === SpotTypeEnum.Mall ? `商场信息` : `周边信息
`,
        children: <FirstScreenRight
          enableBrandCompetitionDistinguish={youthDefaultConfig?.enableBrandCompetitionDistinguish === true}
          detail={detail}
          drawerData={drawerData}
          overViewData={overViewData}
          setStoreChecked={setStoreChecked}
          setSurroundingChecked={setSurroundingChecked}
          curDetail={curDetail}
          setCurDetail={setCurDetail}
          setStoreOptions={setStoreOptions}
          setSurroundingOptions={setSurroundingOptions}
          tenantId={tenantId}
          mapIns={mapIns}
          rangeMarkerRef={rangeMarkerRef}
          setIsOpenHeatMap={setIsOpenHeatMap}
          configSwitch={configSwitch}
          shareParams={shareParams}
          isSemirModel={isSemirModel}
          mainHeight={calculateHeight }
          spotEvaluationConfig={spotEvaluationConfig}
          isStartAnalyseOfAI={isStartAnalyseOfAI}
          setIsStartAnalyseOfAI={setIsStartAnalyseOfAI}
          agentTenant={agentTenant}
        />
      }];
    if (isNotEmptyAny(competitorInfo) || isNotEmptyAny(brandStoreTendency)) {
      list.push(
        {
          key: ActiveKeyEnum.CityInfo,
          label: `${drawerData.cityName}信息`,
          children: <CityInfo
            cityInfo={cityInfo}
            competitorInfo={competitorInfo}
            attentionBrandTopData={brandStoreTendency}
            statesTabs={statesTabs}
            showPlanningBoard={false}
            showCarInsuranceVolume={youthDefaultConfig?.showCarInsuranceVolume}
            mainHeight={calculateHeight }
            tenantId={tenantId}
            drawerData={drawerData}
          />
        },
      );
    }
    return list;
  }, [drawerData, competitorInfo, overViewData, brandStoreTendency, spotEvaluationConfig, mapIns, youthDefaultConfig, calculateHeight, cityInfo, curDetail, isStartAnalyseOfAI]);

  /**
   * @description 图例展示项，只展示有数据的类型
   *
   *  tmpLegendData 接口返回图例/api/surround/poi/legend
   *  storeOptions 所有展示的门店类型 接口获取/api/surround/poi/level_count
   *  surroundingOptions 所有展示的周边配套类型 接口获取/api/surround/model/arroundCategory
   * @return
   */
  const legendData = useMemo(() => {
    if (!isArray(tmpLegendData)) return [];

    const stores = isArray(storeOptions) ? storeOptions : [];
    const surrounds = isArray(surroundingOptions) ? surroundingOptions : [];
    const list = tmpLegendData.filter((itm: any) => {
      const { key, code, aoiTypeCategoryId } = itm;
      // 机会点图例，或者属于有数据展示的门店类型，周边配套
      const isChance = ['MALL_CHANCE_POINT', 'CHANCE_POINT'].includes(key);
      // 本品牌门店
      const isStandardShop = ['MALL_STANDARD_SHOP', 'STANDARD_SHOP'].includes(key);
      const isStores = !!code && stores.some((st: any) => st.code === code);
      const isSurround = surrounds.some((srd: any) => srd.id === aoiTypeCategoryId);
      return isStandardShop || isChance || isStores || isSurround;
    });
    return list;
  }, [tmpLegendData, storeOptions, surroundingOptions]);

  const methods = useMethods({
    loadAgeDetail: async () => {
      const api = tenantId ? spotEvaluationPopulationShare : spotEvaluationPopulation;
      const { type, modelClusterId, lng, lat, modelConfigId } = drawerData;
      const params: any = {
        type,
        modelConfigId
      };
      if (tenantId) {
        params.tenantId = tenantId;
      }
      if (type === SpotTypeEnum.Mall) {
        params.modelClusterId = modelClusterId;
      }
      if (type === SpotTypeEnum.Street) {
        params.lng = lng;
        params.lat = lat;
        params.poiSearchType = detail?.poiSearchType;
        params.radius = detail?.radius;
        params.poiSearchMinute = detail?.poiSearchMinute;
        params.poiSearchDistance = detail?.poiSearchDistance;
        params.points = detail?.points;
      }
      // const params = {
      //   lng: drawerData.lng,
      //   lat: drawerData.lat,
      //   tenantId,
      //   type: drawerData.type,
      //   modelClusterId: drawerData.modelClusterId,
      //   modelConfigId: drawerData.modelConfigId
      // };
      const ageDetailRes = await api(params);
      setAgeDetail(ageDetailRes);
    },
    loadLegend: async () => {
      const api = tenantId ? spotEvaluationLegendShare : spotEvaluationLegend;
      const { type, modelConfigId, modelClusterId, lng, lat } = drawerData;
      const params: any = {
        type,
        modelConfigId,
      };
      if (type === SpotTypeEnum.Mall) {
        params.modelClusterId = modelClusterId;
      }
      if (type === SpotTypeEnum.Street) {
        params.lng = lng;
        params.lat = lat;
        params.poiSearchType = detail?.poiSearchType;
        params.radius = detail?.radius;
        params.poiSearchMinute = detail?.poiSearchMinute;
        params.poiSearchDistance = detail?.poiSearchDistance;
        params.points = detail?.points;
      }
      if (tenantId) {
        params.tenantId = tenantId;
      }
      // const data = await api({
      //   lng: drawerData.lng,
      //   lat: drawerData.lat,
      //   tenantId,
      //   type: drawerData.type,
      //   modelClusterId: drawerData.modelClusterId,
      //   modelConfigId: drawerData.modelConfigId
      // });
      const data = await api(params);
      const targetData = (isArray(data) ? data : []).filter((item) => item.key !== 'CHANCE_POINT').map((item) => ({
        ...item,
        handSwitch: false, // 记录手动开关
        automaticSwitch: false, // 记录自动开关
      }));
      setTmpLegendData(targetData);
    },
    getMapDefaultConfig() {
      const api = tenantId ? postShareYouthMapDefaultConfig : getYouthMapDefaultConfig;
      const params: any = tenantId ? {
        tenantId,
        userId: drawerData.userId,
        modelConfigId: drawerData.modelConfigId,
      } : {};
      // 获取地图默认配置
      api(params).then((res:any) => {
        setYouthDefaultConfig(res);
      });
    },
    // 获取竞品情况
    getCompetitorInfo() {
      const params: any = {
        cityId: drawerData.cityId
      };
      const _tenantId = getCookie('tenantId');
      if (tenantId) {
        params.tenantId = tenantId;
      }
      if (drawerData?.userId) {
        params.userId = drawerData.userId;
      }
      Promise.all([
        getTenantShareInfo({ tenantId: _tenantId || tenantId }),
        // 获取门店状态的数量
        tenantId ? postShareShopStatusCount(params) : postShopStatusCount(params),
        // 城市GDP、人口等信息
        tenantId ? postShareSpotEvaluationCityInfo(params) : getSpotEvaluationCityInfo(params),
        // 本品牌数据开店趋势
        tenantId ? postShareQueryOpeningTendency(params) : postQueryOpeningTendency(params),
        // 竞品品牌开店趋势
        tenantId ? postShareQueryMonthTendency(params) : postQueryMonthTendency(params),
        // 关注品牌
        tenantId ? postShareCombatMapQueryTendencyV2(params) : postCombatMapQueryTendencyV2(params),
        // 点位测评-展示配置：评分/评分维度是否展示等
        tenantId ? getSpotEvaluationShareConfigData(params) : getSpotEvaluationConfigData({}),
      ]).then(([tenantInfo, statesTabs, cityInfo, ownBrand, competitorBrand, newCompetitorBrand, configDataRes]) => {
        setStatesTabs(statesTabs);
        setCityInfo(cityInfo);

        const result = isArray(newCompetitorBrand) ? newCompetitorBrand.sort((a, b) => b.storeNumber - a.storeNumber)?.slice(0, 6) : [];
        const storeTendency = [{ ...ownBrand, brandId: -1, brandName: tenantInfo.ownBrandName || '本品牌' }, ...(competitorBrand || [])];
        setCompetitorInfo(result);
        setBrandStoreTendency(storeTendency);
        setSpotEvaluationConfig(configDataRes);
      });
    },
  });

  return (
    <div
      className={styles.mainCon}
      style={{
        height: mainHeight,
        // 该区域只需要纵向滚动；横向滚动通常来自左右布局 + 内部内容超宽
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
    >
      <div
        className={styles.firstScreenCon}
        style={{
          height: mainHeight,
        }}
      >
        {/* 地图部分 */}
        <FirstScreenMap
          detail={detail}
          drawerData={drawerData}
          mainHeight={mainHeight}
          mapIns={mapIns}
          storeChecked={storeChecked}
          surroundingChecked={surroundingChecked}
          legendData={legendData}
          isMallType={isMallType}
          setMapIns={setMapIns}
          mapDom={mapDom}
          setMapDom={setMapDom}
          curDetail={curDetail}
          setCurDetail={setCurDetail}
          tenantId={tenantId}
          rangeMarkerRef={rangeMarkerRef}
          isOpenHeatMap={isOpenHeatMap}
          // spotEvaluationConfig={spotEvaluationConfig}
        />
        {/* 首屏右侧区域内容 */}
        <V2Tabs
          items={items}
          activeKey={activeKey}
          onChange={(key:string) => setActiveKey((key))}
          className={styles.firstScreenTbs}
        />
      </div>

      {/* 非首屏的懒加载区域 */}
      <div style={{ padding: '0 40px 20px' }}>
        {/* 业态&配套分析 */}
        <TypeOfBusiness detail={detail} />
        {/* <POIMating detail={detail} drawerData={drawerData} tenantId={tenantId}/> */}

        {/* 客流画像 */}
        {passengerFlowPortraitVisible && <PassengerFlowPortrait
          ageDetail={ageDetail}
          overViewData={detail}
          isShareALQ={shareParams?.isALQ}
          // 点位测评都要展示
          showChildData
          // 是点位测评
          isSpotEvaluation
          needHelp
        />}
      </div>
    </div>
  );
};

export default Main;

